// MSAL loginPopup silently fails on many mobile browsers/in-app webviews
// (popups get blocked with no visible error), so those devices must use loginRedirect.
export const isMobileDevice = () => {
  if (typeof navigator === 'undefined') return false;
  if (/Android|iPhone|iPad|iPod|Windows Phone|Mobile/i.test(navigator.userAgent)) return true;
  // iPadOS "desktop" mode reports a Mac user agent but still exposes touch input.
  return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
};
